import { call, put, select } from 'redux-saga/effects';
import { actions as appointmentActions } from '@/reducers/appointment-reducer';
import { actions as errorActions } from '@/reducers/error-reducer';
import { getFormatClientsIds } from '@/sagas/utils/clientIdsUtils';
import { reportJSError } from '@/utils/common';
import { normalizeGetExtraAppointmentOptions } from '@/sagas/appointment/normalizers/appointmentNormalizer';
import { normalizeErrorInfo } from '@/sagas/normalizers/errorNormalizer';
import { getToken } from '@gcloud-npm/utils.recaptcha.get-token';
import appointmentService from '@/services/appointment';
import { WEB_SERVICES } from '@/errorManagement/utils';
import { recaptchaActions } from '../utils/recaptchaUtils';

const segment = (state) => state.formBaf.segment;
const context = (state) => state.main.context;
export function* getExtraAppointmentOptions({ payload }) {
  const contextApi = yield select(context);
  try {
    const params = {};
    params.ga = getFormatClientsIds(contextApi);
    params.frontVersion = process.env.NEXT_PUBLIC_VERSION_JS;
    params.segment = yield select(segment);
    const recaptchaToken = yield call(getToken, {
      action: recaptchaActions.APPOINTMENT,
      recaptchaId: process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID,
    });
    const { data } = payload;
    const {
      geographicSiteId,
      productOfferingId,
      callApi = true,
      calculateFirstAvailableAppointment = false,
    } = {
      ...data,
    };
    if (callApi) {
      const response = yield call(appointmentService, {
        context: contextApi,
        params,
        data: { geographicSiteId, productOfferingId, action: 'ALTA' },
        recaptchaToken,
      });
      const { installAppointmentSlots: appointmentOptions } = { ...response };
      const {
        appointmentOptionsNormalized,
        disabledDays,
        firstAvailableAppointment,
      } = normalizeGetExtraAppointmentOptions(appointmentOptions);
      yield put(
        appointmentActions.getExtraAppointmentOptionsSuccess({
          appointmentOptions: appointmentOptionsNormalized,
          disabledDays,
          firstAvailableAppointment: calculateFirstAvailableAppointment
            ? firstAvailableAppointment
            : null,
        })
      );
    } else {
      yield put(appointmentActions.getExtraAppointmentOptionsSuccess());
    }
  } catch (error) {
    yield put(appointmentActions.getExtraAppointmentOptionsFail());
    reportJSError(
      error,
      'getExtraAppointmentOptions',
      'sagas/appointment/appointment-sagas',
      contextApi
    );
    const errorInfo = normalizeErrorInfo(
      error,
      WEB_SERVICES.GET_EXTRA_APPOINTMENT_OPTIONS,
      contextApi
    );
    yield put(
      errorActions.setError({
        ...errorInfo,
      })
    );
  }
}
